// ── Auth & User ──────────────────────────────────────────────────────────────
export interface AuthResponse {
  token:      string;
  typeLogin:  1 | 2;
  user:       DanoralUser;
  dashboard?: any;
}

export interface DanoralUser {
  id: number;
  nombre: string;
  email?: string;
  nick?: string;
  accesos: number[];
  entidades?: number[];
  entidad?: EntidadInfo;
}

export interface EntidadInfo {
  id: number;
  nombre: string;
  cod: string;
  idPadre?: number;
}

// ── Roles / Accesos ───────────────────────────────────────────────────────────
export enum Acceso {
  ADMINISTRADOR       = 100001,  // Admin total
  ADMIN_RESTRINGIDO   = 100003,  // Admin sin gestion de roles/usuarios
  COD_CLIENTE         = 100004,
  LEGAL               = 100005,
  JUNTA_DIRECTIVA     = 100007,
  AUTOGESTION         = 100008,
  ANALISTA_CONTACTO   = 100011,
  GESTOR_COBRANZA     = 100012,
  EJECUTIVO           = 100013,
  GESTOR_DE_CONTENIDO = 100014,
  SUPERVISOR_IA       = 100099,  // Exclusivo del reporte Interacción Asistente Danoral IA
}

// ── Recibos ───────────────────────────────────────────────────────────────────
export interface Recibo {
  id: number;
  año: number;
  mes: number;
  mesNombre: string;
  monto: number;
  intereses: number;
  total: number;
  estado: 'pendiente' | 'pagado' | 'vencido';
}

// ── Pagos ─────────────────────────────────────────────────────────────────────
export interface NotificacionPago {
  id_Recibo: number;
  banco: string;
  referencia: string;
  monto: number;
  fecha: string;
  observacion?: string;
}

export interface NotificacionPagoResponse {
  ok: boolean;
  message: string;
  emailEnviado: boolean;
}

// ── Gastos ────────────────────────────────────────────────────────────────────
export interface RelacionGastos {
  mes: number;
  año: number;
  mesNombre: string;
  items: GastoItem[];
  total: number;
}

export interface GastoItem {
  descripcion: string;
  monto: number;
  categoria: string;
}

// ── Formas de Pago ────────────────────────────────────────────────────────────
export interface FormaPago {
  id: number;
  banco: string;
  tipoCuenta: string;
  numeroCuenta: string;
  titular: string;
  rif?: string;
  telefono?: string;
  activo: boolean;
}

// ── Contacto ─────────────────────────────────────────────────────────────────
export interface DatoContacto {
  tipo: string;
  tipoCod: number;
  valor: string;
  activo: boolean;
  pendienteConfirm: boolean;
  fecha: string;
}

export interface ActualizarContactoRequest {
  tipo: string;   // '1'=Móvil, '2'=Fijo, '3'=Email
  valor: string;
}

export interface ActualizarContactoResponse {
  ok: boolean;
  message: string;
  requiereConfirmacion: boolean;
}

// ── Cartelera ─────────────────────────────────────────────────────────────────
export interface CarteleroItem {
  id: number;
  titulo: string;
  subTitulo: string;
  texto: string;
  nombreArchivo: string | null;
  fechaInicio: string;
  fechaFin: string;
  tieneArchivo: boolean;
}

// ── Legal / NPL ───────────────────────────────────────────────────────────────
export interface CasoLegal {
  id: number;
  entidad: string;
  estado: string;
  fechaInicio: string;
  deuda: number;
}

// ── Admin ─────────────────────────────────────────────────────────────────────
export interface EstadoCuenta {
  totalDeuda: number;
  totalPagado: number;
  totalPendiente: number;
  entidades: EstadoEntidad[];
}

export interface EstadoEntidad {
  id: number;
  nombre: string;
  deuda: number;
  recibos: number;
}
